import { AccessControl } from 'accesscontrol'
// This is actually how the grants are maintained internally.
const grantsObject = {
  accountAdmin: {
    account: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  appalgotradingvisitor: {
    appalgotrading: {
      'read:any': ['*']
    }
  },
  appanalyticsdemovisitor: {
    appanalyticsdemo: {
      'read:any': ['*']
    }
  },
  appobligationsvisitor: {
    appobligations: {
      'read:any': ['*']
    }
  },
  appreportingvisitor: {
    appreporting: {
      'read:any': ['*']
    }
  },
  apputvisitor: {
    apput: {
      'read:any': ['*']
    }
  },
  articleCreator: {
    article: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  articleEditor: {
    adminMenu: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    articleWorkflowEdit: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    workflow: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*']
    }
  },
  articleReviewer: {
    adminMenu: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    articleWorkflowReview: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  articleApprover: {
    adminMenu: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    articleWorkflowApprove: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  commeditor: {
    comm: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  commvisitor: {
    comm: {
      'read:any': ['*']
    }
  },
  controleditor: {
    control: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    controlrisk: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    controlstatus: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    controltheme: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  controlvisitor: {
    control: {
      'read:any': ['*']
    },
    controlrisk: {
      'read:any': ['*']
    },
    controlstatus: {
      'read:any': ['*']
    },
    controltheme: {
      'read:any': ['*']
    },
    riskcomponent: {
      'read:any': ['*']
    }
  },
  cpdvisitor: {
    cpd: {
      'read:any': ['*']
    }
  },
  faqsvisitor: {
    faq: {
      'read:any': ['*']
    }
  },
  faqseditor: {
    faq: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  faqsapprover: {
    faq: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    faqWorkflowApprove: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  impactadmin: {
    assurance: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    impactstatus: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    impacttopic: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    reportingframework: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    reportingfrequency: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  impactapprover: {
    initiativeWorkflowApprove: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  impacteditor: {
    impactexpert: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    impactinitiative: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    impactobligation: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    regulator: {
      'read:any': ['*']
    }
  },
  impactreporter: {
    impactreport: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  impactsupervisor: {
    impactreportingmi: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  initiativesvisitor: {
    initiative: {
      'read:any': ['*']
    }
  },
  insightsvisitor: {
    article: {
      'read:any': ['*']
    }
  },
  marapprover: {
    caseWorkflowApprove: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  mareditor: {
    assetclass: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    case: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    coverage: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    extsource: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    marrisk: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    person: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    persontype: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    producttype: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  marvisitor: {
    assetclass: {
      'read:any': ['*']
    },
    case: {
      'read:any': ['*']
    },
    coverage: {
      'read:any': ['*']
    },
    extsource: {
      'read:any': ['*']
    },
    marrisk: {
      'read:any': ['*']
    },
    person: {
      'read:any': ['*']
    },
    persontype: {
      'read:any': ['*']
    },
    producttype: {
      'read:any': ['*']
    }
  },
  nfrvisitor: {
    nfrsection: {
      'read:any': ['*']
    }
  },
  obligationsadmin: {
    regulation: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*']
    },
    regulator: {
      'read:any': ['*'],
      'create:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  obligationsvisitor: {
    obligation: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    regulation: {
      'read:any': ['*']
    },
    regulator: {
      'read:any': ['*']
    },
    riskcomponent: {
      'read:any': ['*']
    }
  },
  obligationsapprover: {
    obligationWorkflowApprove: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  policycreator: {
    impactpolicy: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  policyeditor: {
    impactpolicy: {
      'read:any': ['*'],
      'update:any': ['*']
    }
  },
  processeditor: {
    process: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  riccadmin: {
    doc: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    label: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    publication: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*']
    },
    regcategory: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    regtopicgroup: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    riclist: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    stats: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*']
    },
    source: {
      'read:any': ['*'],
      'update:any': ['*']
    },
    tag: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  riccmember: {
    adminMenu: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    analytics: {
      'read:any': ['*']
    },
    article: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    event: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    label: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    newstag: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    publication: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    regulator: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    riclist: {
      'read:any': ['*']
    },
    rricpanel: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    source: {
      'read:any': ['*'],
      'update:any': ['*']
    },
    tag: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*']
    },
    tagspanel: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    topic: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*']
    },
    workflow: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*']
    }
  },
  riccmemberbasic: {
    source: {
      'read:any': ['*'],
      'update:any': ['*']
    },
    topicUpdate: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  riskcomponentadmin: {
    riskcomponent: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  sanctioneditor: {
    sanction: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    schannel: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    scustomer: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    sparty: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    sproduct: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    ssector: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    stype: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  superadmin: {
    adminMenu: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    adminNotifications: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    appimporting: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    faqproject: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    migration: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    project: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    regulation: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    relationship: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    source: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    suggestrule: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    taxonomy: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    topic: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    ugroup: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    user: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    userGroup: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  tagger: {
    newstag: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    source: {
      'read:any': ['*'],
      'update:any': ['*']
    },
    tagspanel: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  trainingcaseapprover: {
    trainingcaseWorkflowApprove: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  trainingcaseeditor: {
    trainingcase: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    }
  },
  trainingcasevisitor: {
    trainingcase: {
      'read:any': ['*']
    }
  },
  norole: {
  }
}
const ac = new AccessControl(grantsObject)
ac.grant('articleReviewer').extend(['articleEditor'])
ac.grant('articleApprover').extend(['articleReviewer'])
ac.grant('impactadmin').extend(['impacteditor'])
ac.grant('obligationsapprover').extend(['obligationsvisitor'])
ac.grant('obligationsadmin').extend(['obligationsapprover'])
ac.grant('riccmember').extend(['impacteditor'])
ac.grant('riccmember').extend(['riccmemberbasic'])
ac.grant('riccadmin').extend(['riccmember'])
ac.grant('trainingcaseapprover').extend(['trainingcaseeditor'])
ac.grant('trainingcaseeditor').extend(['trainingcasevisitor'])
export default ac
